import Button from '@material-ui/core/Button';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost, handleChangeValue, handlePatch } from '../../../../utils/AxiosUtil';
import ErrorAwareTextField from '../../../common/inputfields/ErrorAwareTextField';
import NewAgainField from '../../../common/inputfields/NewAgainField';
import ErrorAwareAmountField from '../../../common/inputfields/ErrorAwareAmountField';
import { toDateFormat, trimSpaces } from '../../../../utils/Util';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import formatRelativeWithOptions from 'date-fns/esm/fp/formatRelativeWithOptions/index.js';
import MyCreatableAutocomplete from '../../../common/inputfields/MyAutocomplete';
import axios from 'axios';

class ModifyCarDay extends Component {

    state = {
        date: new Date(this.props.row.date),
        comment: this.props.row.comment,
        carId: this.props.row.carId,
        licenseNumber: this.props.row.licenseNumber,
        selectedEmployee: this.props.row.driverEmployeeId && { value: this.props.row.driverEmployeeId, label: this.props.row.driverName },
        errors: new Map(),
    }

    componentDidMount() {
        console.log(this.props);
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/carday';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "carId": this.state.carId,
            "licenseNumber": this.state.licenseNumber,
            "date": toDateFormat(this.state.date),
            "driverEmployeeId": this.state.selectedEmployee ? this.state.selectedEmployee.value : null,
            "comment": this.state.comment,
            "active": this.props.row.active
        };
        console.log(requestObject);
        await handlePatch(path, requestObject, this);
    };

    promiseEmployeeOptions = async () => {
        const params = {
            haveDriverLicense: true
        };
        const response = await axios.get('/api/employees', { params })
        return response.data.map(resp => ({
            label: resp.employee.name,
            value: resp.employee.privateId
        }));
    };

    handleEmployeeSelected = (e, v) => {
        this.setState({ selectedEmployee: v })
    }

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="licenseNumber"
                            label="Rendszám"
                            errors={this.state.errors}
                            value={this.state.licenseNumber}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            id="date"
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            onChange={v => handleChangeValue(v, "date", this)}
                        />
                    </div>
                    <div className='input-group'>
                        <MyCreatableAutocomplete
                            value={this.state.selectedEmployee}
                            defaultvale={this.state.selectedEmployee}
                            getOptions={this.promiseEmployeeOptions}
                            onChange={this.handleEmployeeSelected}
                            label={'Söfőr'}
                            required={false}
                        />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyCarDay);
